let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hAfcl")).then(() => parcelRequire('hXg9m'));